import { createOpportunitiesMachine } from '~/features/shared/createOpportunitiesMachine';
import { API_CALLS } from './api';
import type { B2BMessage, B2BOpportunity, B2BOpportunityFilter, B2BResponsesSide } from './types';

export type B2BOpportunitiesContext = {
  opportunities: B2BOpportunity[];
  totalCount: number;
  selectedOpportunity: B2BOpportunity | undefined;
  messages: B2BMessage[];
  filter: B2BOpportunityFilter;
  loading: boolean;
  messagesLoading: boolean;
  error: string | null;
};

// [MCV-1889] The machine reads its list from one Buying | Selling tab, so it is built per side;
// with no side (the flag off) it asks for exactly what it always asked for.
const createJobOpportunitiesMachine = (side?: B2BResponsesSide) =>
  createOpportunitiesMachine<B2BOpportunity, B2BMessage, B2BOpportunityFilter>({
    id: 'b2bJobOpportunities',
    defaultFilter: 'all',
    api: {
      getOpportunities: (filter, signal, includeDeclined) =>
        API_CALLS.getOpportunities(filter, signal, includeDeclined, side),
      getMessages: (responseId, signal) => API_CALLS.getMessages(responseId, signal),
      sendMessage: (responseId, messageBody, signal) =>
        API_CALLS.sendMessage(responseId, messageBody, signal),
      accept: (responseId, expectedNegotiationId, signal, feeAuthorization) =>
        API_CALLS.acceptOpportunity(responseId, expectedNegotiationId, signal, feeAuthorization),
      withdraw: (responseId, signal) => API_CALLS.withdrawOpportunity(responseId, signal),
    },
  });

export const jobOpportunitiesMachine = createJobOpportunitiesMachine();

const machinesBySide = {
  buying: createJobOpportunitiesMachine('buying'),
  selling: createJobOpportunitiesMachine('selling'),
};

export const jobOpportunitiesMachineFor = (side?: B2BResponsesSide) =>
  side ? machinesBySide[side] : jobOpportunitiesMachine;
